import { useMemo } from 'react';

import { paths } from 'src/routes/paths';

import { useTranslate } from 'src/locales';
import { useEntityContext } from 'src/entity/hooks';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useTranslate();
  const { entity } = useEntityContext();

  const data = useMemo(
    () => [
      {
        subheader: '',
        items: [
          {
            title: t('nav.menu.superadmin.users'),
            path: paths.entity.modules.administration.root(entity?.id, entity?.parent_id),
            icon: <Iconify icon="mdi:account-multiple" />,
          },
        ],
      },
    ],
    [t, entity?.id, entity?.parent_id]
  );

  return data;
}
